import { useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <div
      className="flex items-center cursor-pointer bg-blue-600 text-white px-1 hover:underline ml-2"
      onClick={() => navigate(-1)}
    >
      <BiArrowBack size={18} />
      <span className="">Back</span>
    </div>
  );
};

export default BackButton;
